<template>
  <div class="central_content">
    <div style="display: flex; flex-wrap: wrap">
      <div class="search_list">
        <div class="text">组名:</div>
        <Input
          v-model="parameter.groupAlias"
          @input="
            parameter.pageNow = 1;
            getData();
          "
          search
          class="select"
        />
      </div>
      <div class="search_list">
        <div class="text">选择状态:</div>
        <Select
          v-model="parameter.state"
          @on-change="
            parameter.pageNow = 1;
            getData();
          "
          class="select"
        >
          <Option :value="0">未启用</Option>
          <Option :value="1">已启用</Option>
        </Select>
      </div>
      <div class="search_list">
        <Button
          @click="
            upData = {};
            title = '添加';
            reminder1 = true;
          "
          要概述
          type="primary"
        >添加</Button>
      </div>
    </div>
    <Table
      border
      class="table_style"
      :columns="columns"
      :data="userList.list"
      :highlight-row="true"
    >
      <template slot-scope="{ row, index }" slot="state">
        <span v-if="row.state == 0">未开启</span>
        <span v-if="row.state == 1">已开启</span>
      </template>
      <template slot-scope="{ row, index }" slot="type">
        <span v-if="row.type == 1">拉新</span>
        <span v-if="row.type == 2">拉新达标</span>
        <span v-if="row.type == 3">拉新88.88</span>
      </template>
      <template
        slot-scope="{ row, index }"
        slot="commission"
      >{{ (row.commission / 100).toFixed(2) }}</template>
      <template slot-scope="{ row, index }" slot="config">
        <Button
          @click="
            upData = row;
            title = '编辑';
            reminder1 = true;
          "
          type="primary"
        >编辑</Button>
        <Button
          @click="
            upData = row;
            title = '删除';
            reminder1 = true;
          "
          type="primary"
        >删除</Button>
      </template>
    </Table>
    <Modal @on-ok="settleAccounts" width="500" v-model="reminder1" :title="title">
      <div v-if="title == '删除'">删除</div>
      <div v-else>
        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>活动标题:</div>
          <div>
            <Input v-model="upData.title" placeholder="名称" style="width: 300px" />
          </div>
        </div>
        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>简要概述:</div>
          <div>
            <Input v-model="upData.brief" placeholder="简要概述" style="width: 300px" />
          </div>
        </div>

        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>组名:</div>
          <div>
            <Input v-model="upData.groupAlias" placeholder="组名" style="width: 300px" />
          </div>
        </div>
        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>产品id 多个,逗号分割:</div>
          <div>
            <Input
              v-model="upData.psProductIdList"
              placeholder="产品id 多个,逗号分割"
              style="width: 300px"
            />
          </div>
        </div>
        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>达标数量:</div>
          <div>
            <Input v-model="upData.psCount" placeholder="达标数量" style="width: 300px" />
          </div>
        </div>
        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>结束达标数量:</div>
          <div>
            <Input v-model="upData.psCountEnd" placeholder="结束达标数量" style="width: 300px" />
          </div>
        </div>
        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>状态：</div>
          <div>
            <RadioGroup v-model="upData.state">
              <Radio :label="0">未启用</Radio>
              <Radio :label="1">已启用</Radio>
            </RadioGroup>
          </div>
        </div>
        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>活动开始时间:</div>
          <div>
            <DatePicker
              @on-change="startTime"
              v-model="upData.startTime"
              type="datetime"
              format="yyyy-MM-dd HH:mm:ss"
              placeholder="活动开始时间"
              style="width: 200px"
            ></DatePicker>
            <!-- <Input
              v-model="upData.startTime"
              placeholder="活动开始时间"
              style="width: 300px"
            />-->
          </div>
        </div>
        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>活动结束时间:</div>
          <div>
            <DatePicker
              @on-change="endTime"
              v-model="upData.endTime"
              type="datetime"
              format="yyyy-MM-dd HH:mm:ss"
              placeholder="活动结束时间"
              style="width: 200px"
            ></DatePicker>
            <!-- <Input
              v-model="upData.startTime"
              placeholder="endTime"
              style="width: 300px"
            />-->
          </div>
        </div>
        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>达标佣金:</div>
          <div>
            <Input v-model="upData.commission1" placeholder="达标佣金" style="width: 300px" />
          </div>
        </div>
        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>类型:</div>
          <div>
            <RadioGroup v-model="upData.type">
              <Radio :label="1">拉新</Radio>
              <Radio :label="2">拉新达标</Radio>
              <Radio :label="3">拉新88.88</Radio>
            </RadioGroup>
          </div>
        </div>
      </div>
    </Modal>
    <Page :total="userList.total" @on-change="switchover" />
  </div>
</template>

<script>
import { api } from "../biz/api";
export default {
  name: "home",
  data() {
    return {
      title: "",
      parameter: { pageNow: 1 },
      userList: { list: [] },
      remark: null,
      upData: {},
      reminder1: false,
      columns: [
        {
          title: "id",
          align: "center",
          key: "id"
        },
        {
          title: "活动名称",
          align: "center",
          key: "title"
        },
        {
          title: "产品id",
          align: "center",
          key: "psProductIdList"
        },
        {
          title: "达标数量",
          align: "center",
          key: "psCount"
        },
        {
          title: "达标奖励",
          align: "center",
          // slot: "commission",
          key: "commission1"
        },
        {
          title: "结束达标数量",
          align: "center",
          key: "psCountEnd"
        },
        {
          title: "组名",
          align: "center",
          key: "groupAlias"
        },
        {
          title: "状态",
          align: "center",
          slot: "state"
        },
        {
          title: "活动类型",
          align: "center",
          slot: "type"
        },
        {
          title: "简要概述",
          align: "center",
          key: "brief"
        },
        {
          title: "开始时间",
          align: "center",
          key: "startTime"
        },
        {
          title: "结束时间",
          align: "center",
          key: "endTime"
        },
        {
          title: "创建时间",
          align: "center",
          key: "createTime"
        },
        {
          title: "修改时间",
          align: "center",
          key: "modifyTime"
        },
        {
          title: "操作",
          align: "center",
          className: "fontcolor",
          slot: "config",
          width: 200,
          fixed: "right"
        }
      ]
    };
  },
  mounted: function() {
    this.getData();
  },
  methods: {
    startTime(a) {
      this.upData.startTime = a;
    },
    endTime(a) {
      this.upData.endTime = a;
    },
    formatDate(objDate, fmt) {
      var o = {
        "M+": objDate.getMonth() + 1, //月份
        "d+": objDate.getDate() - 1, //日
        "h+": objDate.getHours() % 24 == 0 ? 24 : objDate.getHours() % 24, //小时
        "H+": objDate.getHours(), //小时
        "m+": objDate.getMinutes(), //分
        "s+": objDate.getSeconds(), //秒
        "q+": Math.floor((objDate.getMonth() + 3) / 3), //季度
        S: objDate.getMilliseconds() //毫秒
      };
      if (/(y+)/.test(fmt))
        fmt = fmt.replace(
          RegExp.$1,
          (objDate.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt))
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
      return fmt;
    },
    settleAccounts() {
      if (this.title == "添加") {
        let commission = this.upData.commission1.split(",");
        this.upData.commission = "";
        commission.forEach((element, index) => {
          this.upData.commission += (element * 100).toFixed(0);
          if (index != commission.length - 1) {
            this.upData.commission += ",";
          }
        });
        // if (this.upData.startTime) {
        //   this.upData.startTime = this.formatDate(
        //     new Date(this.upData.startTime),
        //     "yyyy-MM-dd hh:mm:ss.S"
        //   );
        // }
        // if (this.upData.endTime) {
        //   this.upData.endTime = this.formatDate(
        //     new Date(this.upData.endTime),
        //     "yyyy-MM-dd hh:mm:ss.S"
        //   );
        // }
        // this.upData.commission = this.upData.commission1 * 100;
        api.ActivityAdd(this.upData).then(res => {
          if (res.body.status) {
            this.$Message.info(res.body.message);
          }
          this.getData();
        });
      }
      if (this.title == "编辑") {
        // this.upData.commission = this.upData.commission1 * 100;
        let commission = this.upData.commission1.split(",");
        this.upData.commission = "";
        commission.forEach((element, index) => {
          this.upData.commission += (element * 100).toFixed(0);
          if (index != commission.length - 1) {
            this.upData.commission += ",";
          }
        });
        if (this.upData.startTime) {
          this.upData.startTime = this.formatDate(
            new Date(this.upData.startTime),
            "yyyy-MM-dd hh:mm:ss"
          );
        }
        if (this.upData.endTime) {
          this.upData.endTime = this.formatDate(
            new Date(this.upData.endTime),
            "yyyy-MM-dd hh:mm:ss"
          );
        }
        api.ActivityEdit(this.upData).then(res => {
          if (res.body.status) {
            this.$Message.info(res.body.message);
          }
          this.getData();
        });
      }
      if (this.title == "删除") {
        api.ActivityDel(this.upData.id).then(res => {
          if (res.body.status) {
            this.$Message.info(res.body.message);
          }
          this.getData();
        });
      }
    },

    switchover(pageNow) {
      this.parameter.pageNow = pageNow;
      this.getData();
    },

    getData() {
      api.ActivityList(this.parameter).then(res => {
        this.userList = res.body.data;
        this.userList.list.forEach(element => {
          element.commission1 = "";
          let commission = element.commission.split(",");
          commission.forEach((element1, index) => {
            element.commission1 += (element1 / 100).toFixed(2);
            if (index != commission.length - 1) {
              element.commission1 += ",";
            }
          });
        });
      });
    }
  }
};
</script>

<style scoped>
</style>